import { useMutation, useQueryClient } from '@tanstack/react-query'
import { academicTermsApi, UpdateProgramAcademicTermPayload } from './api'
import { parseAcademicTermsDateError } from './utils'
import { parseRequestError } from '@/app/common/utilities'
import { useToast } from '@/shad/ui/toast/use-toast'
import { academicTermsKeys } from './keys'

function useUpdateProgramAcademicTerm(programId: number) {
  const { toast } = useToast()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: UpdateProgramAcademicTermPayload) => {
      return await academicTermsApi.updateProgramAcademicTerm(payload)
    },
    onSuccess: () => {
      toast({
        title: 'Award Dates Updated',
        description: 'Award dates have been updated successfully',
        variant: 'default',
      })

      queryClient.refetchQueries({
        queryKey: academicTermsKeys.programAcademicTerms(programId),
      })
    },
    onError: (error) => {
      const parsedError = parseRequestError(error)
      const errorData = parseAcademicTermsDateError(parsedError)
      toast({
        title: 'Error Updating Award Dates',
        description: errorData,
        variant: 'destructive',
      })
    },
  })
}

export { useUpdateProgramAcademicTerm }
